import { take, takeEvery, put } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import { queryPosts } from 'wordpress/actions'
import { POSTS_RECEIVED } from 'wordpress/constants'
import { setNews } from 'news/actions'
import getRandomness from 'shared/random-generator'

import * as constants from './constants'

export default function* rootSaga() {
    yield takeEvery(constants.GET_NEWS, indicateProgress, 'news', function* ({ category, search, page }) {
        const requestId = getRandomness()

        yield put(
            queryPosts(
                'news',
                {
                    categories: category ? [category.id] : null,
                    search,
                    page,
                    per_page: 10,
                },
                requestId
            )
        )

        const {
            result: { posts, paging },
        } = yield take(action => action.type === POSTS_RECEIVED && action.requestId === requestId)
        yield put(setNews(posts, paging))
    })
}
